<div class="container" style="font-size:0.9rem; margin-bottom: 40px;">
  <div style="background-color: var(--bg-card); padding:25px;">
    <div style="text-align: left;">
      <h2 class="mb-3">Release Notes</h2>


      <div style="font-size: 1em;">


        <h3>Version 2.14.24 - Nov 4, 2026</h3>
        <ul>
            <li>Company Settings Security Improvements</li>
            <li>“Required Haulex App” For Carriers Can Now Be Turned On/Off</li>
            <li>Templates Fixes</li>
        </ul>

        <h3>Version 2.14.23 - Nov 2, 2026</h3>
        <ul>
            <li>Drivers Report New Dates</li>
            <li>Adjustment Summary Report Date Improvements</li>
            <li>Email Validation Fixes</li>
        </ul>

        <h3>Version 2.14.22 - Oct 27, 2026</h3>
        <ul>
            <li>Filler Request Improvements</li>
            <li>Dialpad Subscriptions Improvements/li>
        </ul>


        <h3>Version 2.14.21 - Oct 27, 2026</h3>
        <ul>
            <li>Signature Pad Fixes</li>
        </ul>

        <h3>Version 2.14.20 - Oct 22, 2026</h3>
        <ul>
            <li>QB Fixes/Improvements for Shop Orders</li>
        </ul>

        <h3>Version 2.14.19 - Oct 21, 2026</h3>
        <ul>
            <li>Connect QB for Shop Orders</li>
        </ul>

        <h3>Version 2.14.18 - Oct 20, 2026</h3>
        <ul>
            <li>Remove Fee For Charge Customer From Haulex</li>
            <li>Show Deactivated Drivers For Reports</li>
            <li>Fix Notifications For Adjustments/li>
        </ul>

        <h3>Version 2.14.17 - Oct 16, 2026</h3>
        <ul>
            <li>Add Original Date For Carrier Side</li>
            <li>Improve Logistic Performance Report</li>
            <li>Fix Inspection Dates</li>
        </ul>

        <h3>Version 2.14.16 - Oct 14, 2026</h3>
        <ul>
            <li>Fix Tracking Enable After Order Reopen</li>
            <li>Fix Charge Customer From Haulex</li>
            <li>Task List Fixes</li>
        </ul>


        <h3>Version 2.14.15 - Oct 9, 2026</h3>
        <ul>
            <li>Filter By Deleted Bell Notifications</li>
            <li>Improve And Fixes Email Tracking</li>
        </ul>

        <h3>Version 2.14.14 - Oct 7, 2026</h3>
        <ul>
            <li>Add Call Tracking</li>
            <li>Fix Notes And File Visibility For Recruiter</li>
            <li>Layout Fixes</li>
        </ul>

        <h3>Version 2.14.13 - Oct 2, 2026</h3>
        <ul>
            <li>Driver Adjustment Report</li>
            <li>Locks Work Improve and Fix</li>
            <li>Minor Fixes</li>
        </ul>

        <h3>Version 2.14.12 - Oct 1, 2026</h3>
        <ul>
            <li>Fix Order Accept From Order Details</li>
            <li>Fix Loading Notifications</li>
            <li>Minor Fixes For Filter Count</li>
        </ul>

        <h3>Version 2.14.11 - Sep 28, 2026</h3>
        <ul>
            <li>Email History</li>
            <li>Fix Minor Adaptive Issues</li>
        </ul>

        <h3>Version 2.14.10 - Sep 18, 2026</h3>
        <ul>
            <li>Mobile Version For Quote List</li>
            <li>Auto Import From Syngin</li>
            <li>Fix P&L By Truck</li>
        </ul>

        <h3>Version 2.14.9 - Sep 16, 2026</h3>
        <ul>
            <li>Locks Fixes</li>
            <li>Follow-Up Template Fixes</li>
            <li>Update Links To New Android App</li>
        </ul>

        <h3>Version 2.14.8 - Sep 11, 2026</h3>
        <ul>
            <li>Yard Functional</li>
            <li>Filters For Equipment List</li>
            <li>Not Paid Invoices Fix</li>
            <li>Shop Layout Fixes</li>
            <li>Notification Templates Improvements</li>
        </ul>

        <h3>Version 2.14.7 - Sep 7, 2026</h3>
        <ul>
            <li>Syngin Integration</li>
            <li>Checkout Minor Fixes</li>
            <li>SMS Improvements</li>
        </ul>

        <h3>Version 2.14.6 - Sep 2, 2026</h3>
        <ul>
            <li>Fix Address Input</li>
        </ul>

        <h3>Version 2.14.5 - Sep 1, 2026</h3>
        <ul>
            <li>Black Theme</li>
            <li>Minor Fixes For Body Type For Imported Orders</li>
        </ul>


        <h3>Version 2.14.4 - Aug 21, 2026</h3>
        <ul>
            <li>Password Management</li>
            <li>Haulex Importer Improvements</li>
        </ul>

        <h3>Version 2.14.3 - Aug 20, 2026</h3>
        <ul>
            <li>Customer Live Tracking V1 (Only for drivers who have enabled this option)</li>
            <li>Minor Central Dispatch API Fixes</li>
            <li>Fix Vehicle Count on Loadboard</li>
        </ul>

        <h3>Version 2.14.2 - Aug 14, 2026</h3>
        <ul>
            <li>Removed Date Limitation from Carrier Request Modal</li>
        </ul>

        <h3>Version 2.14.1 - Aug 10, 2026</h3>
        <ul>
            <li>Improve Signature Delete</li>
            <li>Improve Default Item/Service For Invoices From Checkout</li>
            <li>Mark As Filler Functional</li>
        </ul>

        <h3>Version 2.14.0 - Aug 6, 2026</h3>
        <ul>
            <li>Connect CD Api</li>
            <li>Reminder For Carrier To Send Invoice Info</li>
        </ul>


        <h3>Version 2.13.14 - Aug 5, 2026</h3>
        <ul>
            <li>Super Dispatch Fix Import</li>
            <li>Filter By Broker Fee</li>
            <li>Fix Filter By Driver/Dispatcher</li>
        </ul>

        <h3>Version 2.13.13 - Aug 1, 2026</h3>
        <ul>
            <li>Refund Report By Agents</li>
            <li>Signature For Contract</li>
            <li>Filter By Haul Type for Truck Report</li>
        </ul>

        <h3>Version 2.13.12 - Jul 31, 2026</h3>
        <ul>
            <li>Allow to Pin Task From Details</li>
            <li>Add Search by Carrier's Phones</li>
            <li>New Tag for Orders</li>
            <li>Angular 22</li>
        </ul>

        <h3>Version 2.13.11 - Jul 17, 2026</h3>
        <ul>
            <li>Update Dispatch Emails</li>
            <li>Add Insurance Category For Expense</li>
        </ul>

        <h3>Version 2.13.10 - Jul 16, 2026</h3>
        <ul>
            <li>Allow to Calculate Summary for Fuel in Trip List</li>
            <li>Show Trip Duration</li>
            <li>Exclude Filter for AR Aging Summary Report</li>
        </ul>

        <h3>Version 2.13.9 - Jul 14, 2026</h3>
        <ul>
            <li>Attach Contract After Carrier Accept</li>
            <li>New Category For Expenses<li>
            <li>Show Full Date On Shop Orders</li>
            <li>Locks Minor Fixes</li>
        </ul>

        <h3>Version 2.13.8 - Jul 10, 2026</h3>
        <ul>
            <li>Trip Expense Improvements<li>
        </ul>

        <h3>Version 2.13.7 - Jul 8, 2026</h3>
        <ul>
            <li>Samsara Integration Improvements<li>
            <li>Bulk Update Minor Fixes</li>
        </ul>

        <h3>Version 2.13.6 - Jul 2, 2026</h3>
        <ul>
           <li>Minor Fixes</li>
        </ul>

        <h3>Version 2.13.5 - Jun 25, 2026</h3>
        <ul>
            <li>Split Carriers And Broker Dates</li>
            <li>Checkout Addresses Fixes</li>
        </ul>

        <h3>Version 2.13.4 - Jun 17, 2026</h3>
        <ul>
            <li>Ability to Add Simulated Orders to a Trip for Route Assessment</li>
            <li>Improve Photos Loading on Inspection</li>
            <li>Cash Only Since Date</li>
        </ul>

        <h3>Version 2.13.3 - Jun 17, 2026</h3>
        <ul>
            <li>Minor Fix For Dates Editing</li>
        </ul>

        <h3>Version 2.13.2 - Jun 17, 2026</h3>
        <ul>
            <li>Don't Allow To Add Driver If Customer Is Empty</li>
            <li>Fix Bill Creating</li>
            <li>Show Correct Count In Expense Tabs</li>
        </ul>

        <h3>Version 2.13.1 - Jun 16, 2026</h3>
        <ul>
            <li>Fix Terms & Conditions Link</li>
        </ul>

        <h3>Version 2.13.0 - Jun 16, 2026</h3>
        <ul>
            <li>Lock System Refactoring</li>
            <li>Deposit Fill Automatically Fixes</li>
            <li>Payment Acknowledgment Issue</li>
            <li>Expirations For Deleted Driver Fixes</li>
        </ul>


        <h3>Version 2.12.20 - Jun 9, 2026</h3>
        <ul>
            <li>Fill Deposit Automatically</li>
            <li>Driver ETA Fixes</li>
        </ul>

        <h3>Version 2.12.19 - Jun 3, 2026</h3>
        <ul>
            <li>Driver ETA Field</li>
            <li>Dispatcher Amount On List</li>
            <li>Slack Status Integration</li>
            <li>Stop Overwrite Improvements</li>
        </ul>

        <h3>Version 2.12.17-18 - Jun 3, 2026</h3>
        <ul>
            <li>Cental Dispatch Posting Count</li>
        </ul>

        <h3>Version 2.12.16 - Jun 2, 2026</h3>
        <ul>
            <li>Fix QuickBook Scheme Update</li>
            <li>Duplicate Yards Fixes</li>
        </ul>

        <h3>Version 2.12.15 - Jun 1, 2026</h3>
        <ul>
            <li>Fix Follow Ups</li>
        </ul>

        <h3>Version 2.12.14 - Jun 1, 2026</h3>
        <ul>
            <li>Quick Book For Checkout Payments</li>
            <li>Trip Payroll Report</li>
        </ul>

        <h3>Version 2.12.13 - May 27, 2026</h3>
        <ul>
            <li>Lock Improvements</li>
            <li>Backend Fixes</li>
        </ul>

        <h3>Version 2.12.12 - May 22, 2026</h3>
        <ul>
            <li>Remove Stage Buttons</li>
            <li>Due Invoice Improvements</li>
        </ul>

        <h3>Version 2.12.11 - May 20, 2026</h3>
        <ul>
            <li>Time When The Auto Assignment Was Turned Off</li>
            <li>Minor Fixes</li>
        </ul>

        <h3>Version 2.12.10 - May 18, 2026</h3>
        <ul>
            <li>Paid Button For Dispatcher</li>
            <li>Fix Settings For Mobile</li>
        </ul>

        <h3>Version 2.12.9 - May 15, 2026</h3>
        <ul>
            <li>Orders Sorting Improved For Drivers</li>
            <li>DB Optimizations</li>
        </ul>

        <h3>Version 2.12.8 - May 13, 2026</h3>
        <ul>
            <li>Auto Assign Improvements</li>
            <li>Get a Quote Disable Fixes</li>
            <li>PDF Import Improvements</li>
        </ul>

        <h3>Version 2.12.7 - May 13, 2026</h3>
        <ul>
            <li>Push Notification For Driver When Trip Changed</li>
            <li>Remove Inactive Users From Sidebar</li>
        </ul>


        <h3>Version 2.12.6 - May 8, 2026</h3>
        <ul>
            <li>Functional For Duplication Leads For Other Companies</li>
            <li>Fixes Trip Overwriting</li>
            <li>Template Changes</li>
        </ul>

        <h3>Version 2.12.5 - May 6, 2026</h3>
        <ul>
            <li>Fix Claims Driver Filter Bug</li>
            <li>Fix Access Hours Disappear From Stop Bug</li>
        </ul>

        <h3>Version 2.12.4 - May 1, 2026</h3>
        <ul>
            <li>Improve Customer Search</li>
            <li>Fix Import PDF Bug</li>
            <li>Import From CD Fixes</li>
            <li>Don't Allow To Edit Contacts Higher Than You</li>
            <li>History Improvements V2</li>
            <li>Minor Fixes</li>
        </ul>

        <h3>Version 2.12.3 - May 1, 2026</h3>
        <ul>
            <li>Improve Contact Deduplication</li>
        </ul>

        <h3>Version 2.12.2 - Apr 29, 2026</h3>
        <ul>
            <li>Dispatcher Salary v1</li>
            <li>Fix Removing Customer From Parent</li>
        </ul>

        <h3>Version 2.12.1 - Apr 28, 2026</h3>
        <ul>
            <li>Fix Showing Correct Date in History</li>
            <li>Due Invoices Report Improvements</li>
        </ul>

        <h3>Version 2.12.0 - Apr 27, 2026</h3>
        <ul>
            <li>Starting Integration Push Notification For Mobile App</li>
            <li>Fix Restoring Sub Orders</li>
            <li>Accounting Fixes For Merged Accounts</li>
            <li>Fix Damage Markers Position</li>
        </ul>

        <h3>Version 2.11.23 - Apr 24, 2026</h3>
        <ul>
            <li>After Carrier Accept Show Contract</li>
            <li>Add Colors For Resolution Status</li>
            <li>Add Ref Number to Due Invoices Report</li>
            <li>Fix Importer Payment Data</li>
        </ul>

        <h3>Version 2.11.22 - Apr 23, 2026</h3>
        <ul>
            <li>Duplicate Expenses Flow</li>
            <li>Cancellation Automation</li>
        </ul>
        <h3>Version 2.11.21 - Apr 22, 2026</h3>
        <ul>
            <li>Accounting overdue invoice workflow</li>
        </ul>

        <h3>Version 2.11.20 - Apr 21, 2026</h3>
        <ul>
            <li>Dialpad Integration</li>
            <li>Upload Photos Fixes</li>
        </ul>

        <h3>Version 2.11.19 - Apr 20, 2026</h3>
        <ul>
            <li>Trip Overwriting Fixes</li>
            <li>Quote Modal Improvements</li>
            <li>Public Order Update Fixes</li>
        </ul>

        <h3>Version 2.11.18 - Apr 14, 2026</h3>
        <ul>
            <li>Fix History Minor Issue</li>
            <li>Improvements for Terms & Conditions Link</li>
        </ul>

        <h3>Version 2.11.17 - Apr 14, 2026</h3>
        <ul>
            <li>Change Email Templates - Showing Correct Emails</li>
        </ul>

        <h3>Version 2.11.16 - Apr 10, 2026</h3>
        <ul>
            <li>Separate Logic Checkout From Websites and Order Details</li>
            <li>Allow to Generate Checkout without Email Automation</li>
            <li>Allow To Download Inspection Photos In Different Qualities</li>
        </ul>

        <h3>Version 2.11.15 - Apr 9, 2026</h3>
        <ul>
            <li>Fix Order Details UI</li>
            <li>Dispatcher Exclusion Filter for Report By Customer</li>
            <li>Fix Trip Overwrite Issue</li>
        </ul>

        <h3>Version 2.11.13 - Apr 8, 2026</h3>
        <ul>
            <li>Improvements for Authorize.NET</li>
        </ul>

        <h3>Version 2.11.12 - Apr 8, 2026</h3>
        <ul>
            <li>Allow to Customize Columns In Source Report</li>
            <li>Add Search Button for Curb Weight</li>
        </ul>

        <h3>Version 2.11.11 - Apr 7, 2026</h3>
        <ul>
            <li>Fix CSV Report For Sales Commissions</li>
            <li>Filter By Days Between Splits</li>
            <li>Added Curb Weight Validation</li>
            <li>VIN Decoder For New Quote Modal</li>
        </ul>

        <h3>Version 2.11.10 - Apr 3, 2026</h3>
        <ul>
            <li>Rollback - Fix Terms&Conditions Public Link</li>
        </ul>
        <h3>Version 2.11.9 - Apr 3, 2026</h3>
        <ul>
            <li>Update Sources For Companies That Have Default</li>
            <li>Fix Checkout When Order Was Deleted</li>
            <li>Fix Customer Filter</li>
            <li>Fix Terms&Conditions Public Link</li>
        </ul>

        <h3>Version 2.11.8 - Apr 1, 2026</h3>
        <ul>
            <li>Allow To Upload Signature for Custom BOL</li>
            <li>New Emails For Due Invoices</li>
            <li>Allow to Select All Order in Trip Details</li>
        </ul>
        <h3>Version 2.11.7 - Mar 31, 2026</h3>
        <ul>
            <li>Fix Trip End Date</li>
            <li>Fix Lead Outcome Breakdown Report</li>
            <li>Filter by Terms in Due Invoices Report</li>
        </ul>

        <h3>Version 2.11.5 - Mar 27, 2026</h3>
        <ul>
            <li>Fix ZIP Code Search</li>
            <li>Fix Dates From Quote Form</li>
            <li>Fix Default Source</li>
        </ul>

        <h3>Version 2.11.4 - Mar 26, 2026</h3>
        <ul>
            <li>Fix Stops Color Indicators</li>
            <li>Confirmation Report</li>
            <li>Fix Customers That Was Merged From TAT</li>
        </ul>

        <h3>Version 2.11.3 - Mar 23, 2026</h3>
        <ul>
            <li>REVERT - Trip Outline Fixes</li>
        </ul>

        <h3>Version 2.11.2 - Mar 23, 2026</h3>
        <ul>
            <li>Trip Outline Fixes</li>
            <li>Source Report Allow To Filter By Active/Inactive Users</li>
            <li>Sorting Inspections Photos</li>
            <li>Change Reply Stop Text in SMS</li>
        </ul>

        <h3>Version 2.11.1 - Mar 18, 2026</h3>
        <ul>
            <li>Fix Trip Revenue Issue</li>
            <li>Show Follow Ups In "ALL" Tab</li>
        </ul>

        <h3>Version 2.11.0 - Mar 18, 2026</h3>
        <ul>
            <li>Import Contract From PDF (Beta)</li>
            <li>Fix Trip Deleting Issue</li>
            <li>Improvements For Invoice Reminders</li>
        </ul>

        <h3>Version 2.10.19 - Mar 18, 2026</h3>
        <ul>
            <li>Due Invoices Report</li>
        </ul>

        <h3>Version 2.10.18 - Mar 17, 2026</h3>
        <ul>
            <li>Change Confirmation Logic. Now It Works Separately For Each Company</li>
            <li>Reminders For Due Invoices</li>
        </ul>

        <h3>Version 2.10.17 - Mar 13, 2026</h3>
        <ul>
            <li>Fix Shop Order PDF</li>
            <li>Minor Update Date In Quote Model</li>
        </ul>

        <h3>Version 2.10.16 - Mar 13, 2026</h3>
        <ul>
            <li>Add Quote Modal </li>
        </ul>

        <h3>Version 2.10.15 - Mar 12, 2026</h3>
        <ul>
            <li>Fix Generate Price From Order Details</li>
            <li>Show Partial Paid In Order List</li>
        </ul>

        <h3>Version 2.10.14 - Mar 11, 2026</h3>
        <ul>
            <li>Fix Accounting Stats For Brokers</li>
            <li>Default Source For Customers</li>
        </ul>

        <h3>Version 2.10.13 - Mar 10, 2026</h3>
        <ul>
            <li>Add Ability To Add Accounting Email And Phone For Customers</li>
            <li>Send Bell Notification For Order Assignee After Carrier Accept</li>
            <li>Fix Problem With OTP On Mobile</li>
        </ul>

        <h3>Version 2.10.12 - Mar 04, 2026</h3>
        <ul>
            <li>Improve History View</li>
            <li>Fix Carrier Accept Overwrite</li>
        </ul>

        <h3>Version 2.10.10 - Mar 03, 2026</h3>
        <ul>
            <li>Trip Outline Fixes</li>
            <li>Meta Lead Tracking</li>
            <li>Code Optimizations</li>
        </ul>

        <h3>Version 2.10.9 - Feb 27, 2026</h3>
        <ul>
            <li>Allow To Create Checkout And Start Automation Inside Order Details</li>
            <li>Signature Fixes</li>
            <li>A Lot Of Minor Fixes</li>
        </ul>


        <h3>Version 2.10.8 - Feb 26, 2026</h3>
        <ul>
            <li>Polylines Fixes</li>
            <li>Total Miles Fixes</li>
        </ul>

        <h3>Version 2.10.7 - Feb 24, 2026</h3>
        <ul>
            <li>Improve Logistics Performance Report</li>
            <li>Fix Overwrite Trip Data</li>
        </ul>

        <h3>Version 2.10.6 - Feb 23, 2026</h3>
        <ul>
            <li>Allow to Turn Off Email Automation</li>
            <li>Fix Email Validation from Mobile</li>
        </ul>

        <h3>Version 2.10.5 - Feb 19, 2026</h3>
        <ul>
            <li>Fix Suggested Carriers Notify</li>
            <li>Fix 'Ready for Pickup' Filter</li>
            <li>Update Mobile Settings Label</li>
        </ul>


        <h3>Version 2.10.4 - Feb 17, 2026</h3>
        <ul>
            <li>Remove Filter From Marketing Report</li>
            <li>Unlock Request Issue Fix</li>
            <li>Email Marketing Improvements</li>
        </ul>

        <h3>Version 2.10.3 - Feb 11, 2026</h3>
        <ul>
            <li>Add Filters For Some Reports</li>
            <li>Show Conversion Info In Report</li>
            <li>Backend Optimizations</li>
        </ul>

        <h3>Version 2.10.2 - Feb 11, 2026</h3>
        <ul>
            <li>Add Google Cabinets Integration</li>
            <li>Improve CC Fee Logic</li>
        </ul>

        <h3>Version 2.10.1 - Feb 11, 2026</h3>
        <ul>
            <li>Fix File Uploading</li>
            <li>Remove Useless Fields</li>
        </ul>

        <h3>Version 2.10.0 - Feb 06, 2026</h3>
        <ul>
            <li>Fix Visibility Of Claim For Broker</li>
            <li>Fix Creating Expense Without Resource</li>
            <li>Add Advertisement Category To Expense Accounts For Bills Category</li>
            <li>Fix Sorting Orders On Vehicle Inspection</li>
        </ul>

        <h3>Version 2.9.15 - Jan 30, 2026</h3>
        <ul>
            <li>Fix Unsubscribe Phones Logic</li>
            <li>Show UTD Data Inside Order Details</li>
            <li>CC Fee Improvements</li>
        </ul>

        <h3>Version 2.9.14 - Jan 28, 2026</h3>
        <ul>
            <li>Fix Import Payment Details From Central Dispatch</li>
            <li>Delete Split Order For Carrier After Carrier Reset</li>
            <li>Fix Dealer Portal</li>
        </ul>

        <h3>Version 2.9.13 - Jan 27, 2026</h3>
        <ul>
            <li>Add Dispatcher Pay Rate To Trip Report</li>
            <li>Add Refund Filter</li>
            <li>Update Broker Dashboard Design</li>
            <li>Fix CSV Reports</li>
        </ul>

        <h3>Version 2.9.12 - Jan 22, 2026</h3>
        <ul>
            <li>Allow to Hide Quote Form For Customer</li>
            <li>Fix VIN Validation</li>
        </ul>

        <h3>Version 2.9.11 - Jan 22, 2026</h3>
        <ul>
            <li>Fix Clone Order for CC Fee</li>
            <li>Switch Filters</li>
        </ul>

        <h3>Version 2.9.10 - Jan 22, 2026</h3>
        <ul>
            <li>Improve Dealer Portal v2</li>
            <li>Remove Order From CD after Order Delete</li>
            <li>Add Filter by Bill Status</li>
        </ul>

        <h3>Version 2.9.9 - Jan 20, 2026</h3>
        <ul>
            <li>Rename Refund Receipt</li>
            <li>Add CC Fee Toggle</li>
        </ul>

        <h3>Version 2.9.8 - Jan 16, 2026</h3>
        <ul>
            <li>Avg Cost Per Mile For Dispatcher Trips Report</li>
        </ul>

        <h3>Version 2.9.7 - Jan 16, 2026</h3>
        <ul>
            <li>Refound Functionality</li>
            <li>Google Multiply Accounts</li>
        </ul>

        <h3>Version 2.9.6 - Jan 15, 2026</h3>
        <ul>
            <li>Fix Confirmation Stop Template</li>
            <li>Fix Login Contact Issue</li>
        </ul>

        <h3>Version 2.9.5 - Jan 14, 2026</h3>
        <ul>
            <li>Add VIN Validation</li>
            <li>Fix Order List Errors</li>
            <li>Don't Lock Notes</li>
        </ul>

        <h3>Version 2.9.4 - Jan 13, 2026</h3>
        <ul>
            <li>Fix Stop Render Issue</li>
            <li>Added Validation For Accounting Carrier Pay</li>
            <li>Accounting Improvements (CC email, name changes)</li>
            <li>Quick Book Profit And Loss by Month</li>
        </ul>


        <h3>Version 2.9.3 - Jan 12, 2026</h3>
        <ul>
            <li>Fix Invoice Date in Order Details</li>
            <li>Chart of Accounts Improvements</li>
            <li>Optimization For Order List</li>
            <li>History For Public Updates</li>
            <li>Fix Dashboard Revenue</li>
        </ul>


        <h3>Version 2.9.2 - Jan 08, 2026</h3>
        <ul>
            <li>Update Angular 21</li>
            <li>Driver Qualification Options</li>
            <li>Improve Filter For Work Order</li>
        </ul>

        <h3>Version 2.9.1 - Jan 07, 2026</h3>
        <ul>
            <li>Redesign INOP Filter</li>
            <li>Show Dates for Invoices And Bill in Order Details</li>
            <li>Hot Fix Sales Agent Conversion Report</li>
        </ul>

        <h3>Version 2.9.0 - Jan 05, 2026</h3>
        <ul>
            <li>Fix Default BOL Fields</li>
            <li>Pull Business Hours From Agent Info</li>
            <li>Filter By Work Order In Expenses</li>
        </ul>

        <h3>Version 2.8.83 - Dec 26, 2025</h3>
        <ul>
            <li>Fix Equipment List</li>
            <li>Add Metrics for Google</li>
            <li>Send Notification about Order Confirmation</li>
        </ul>

        <h3>Version 2.8.82 - Dec 22, 2025</h3>
        <ul>
            <li>Download Contract After Carrier Accept</li>
            <li>Add INOP Vehicle Filter For Order List</li>
            <li>Show History For Bill</li>
            <li>Show Tags Under Status in Order List</li>
        </ul>

        <h3>Version 2.8.81 - Dec 22, 2025</h3>
        <ul>
            <li>Connect Reports From QuickBook</li>
        </ul>

        <h3>Version 2.8.80 - Dec 20, 2025</h3>
        <ul>
            <li>Show Full Date For Equipment Expirations</li>
            <li>Fix QuickPay Fee</li>
            <li>Fix FollowUp SMS Count</li>
        </ul>
        <h3>Version 2.8.79 - Dec 19, 2025</h3>
        <ul>
            <li>Improve Terms & Conditions On Checkout</li>
            <li>Notification Sorting Fix</li>
            <li>Source Report Redirect Changes</li>
            <li>Expense Bulk Update Fixes</li>
        </ul>

        <h3>Version 2.8.77 - Dec 16, 2025</h3>
        <ul>
            <li>Add Terms & Conditions To Checkout</li>
            <li>Ring Central SMS Spam Improvements</li>
        </ul>

        <h3>Version 2.8.76 - Dec 08, 2025</h3>
        <ul>
            <li>Fix CRM Loading Issue</li>
            <li>Ring Central SMS History</li>
        </ul>

        <h3>Version 2.8.75 - Dec 08, 2025</h3>
        <ul>
            <li>Revert Trip Changes</li>
        </ul>

        <h3>Version 2.8.74 - Dec 08, 2025</h3>
        <ul>
            <li>Show Green Quote Count in Search</li>
            <li>Accounting Improvements</li>
        </ul>

        <h3>Version 2.8.73 - Dec 08, 2025</h3>
        <ul>
            <li>Fix Time On Inspection Photos</li>
            <li>Fix Inputs In Accounting For Carrier</li>
        </ul>

        <h3>Version 2.8.72 - Dec 08, 2025</h3>
        <ul>
            <li>Improve Trip Outlines Loading</li>
            <li>Claim Bucket Updates</li>
            <li>Improve Phone Verification</li>
        </ul>

        <h3>Version 2.8.71 - Dec 02, 2025</h3>
        <ul>
            <li>Remove Email Campaigns From Sources Report</li>
            <li>Show Original Date in Order List</li>
            <li>Improve Conversion System</li>
        </ul>

        <h3>Version 2.8.70 - Nov 28, 2025</h3>
        <ul>
            <li>Show Amount In For Invoices Inside Order Details</li>
            <li>Fix $ Icon in Order List</li>
            <li>Allow to Set Bill Date</li>
            <li>Always Show Follow Ups In Order</li>
        </ul>

        <h3>Version 2.8.69 - Nov 27, 2025</h3>
        <ul>
            <li>Carrier Invoice Improvements v2</li>
            <li>Update Email Marketing. Show the Lowest Price</li>
        </ul>


        <h3>Version 2.8.68 - Nov 25, 2025</h3>
        <ul>
            <li>Allow to Open on Fullscreen Dashboard</li>
            <li>Fix Open Inspection for List</li>
        </ul>

        <h3>Version 2.8.67 - Nov 25, 2025</h3>
        <ul>
            <li>Allow to Create Bills in Haulex</li>
            <li>Add 'Reply STOP' for Ring Central</li>
        </ul>

        <h3>Version 2.8.66 - Nov 24, 2025</h3>
        <ul>
            <li>Fix Importer From Central Dispatch and ShipCars</li>
            <li>Fix Trip Report Issues</li>
        </ul>

        <h3>Version 2.8.65 - Nov 21, 2025</h3>
        <ul>
            <li>Trip Report Driver Collect Improvements</li>
            <li>Filter By Truck in Expenses</li>
            <li>5% for Quick Pay as default fee</li>
        </ul>

        <h3>Version 2.8.63 - Nov 20, 2025</h3>
        <ul>
            <li>Expense Report UI Changes</li>
            <li>Fix Saving First SMS after Quote</li>
        </ul>

        <h3>Version 2.8.62 - Nov 20, 2025</h3>
        <ul>
            <li>Allow to Pin Tasks in Sidebar</li>
            <li>Ring Central Integration Improvements</li>
        </ul>

        <h3>Version 2.8.61 - Nov 20, 2025</h3>
        <ul>
            <li>Fix Trip Pay Rate Issue</li>
        </ul>

        <h3>Version 2.8.60 - Nov 19, 2025</h3>
        <ul>
            <li>Broker Dashboard Changes (Calculate Converted Orders By Pickup Date)</li>
            <li>Allow To Create Invoices For Carrier</li>
        </ul>

        <h3>Version 2.8.59 - Nov 18, 2025</h3>
        <ul>
            <li>Hot Fix For Assigning Truck in Claim</li>
        </ul>

        <h3>Version 2.8.58 - Nov 18, 2025</h3>
        <ul>
          <li>Fix Creating Empty Inspection on Web</li>
            <li>Qualified Leads System for Google</li>
        </ul>

        <h3>Version 2.8.56 - Nov 17, 2025</h3>
        <ul>
            <li>Improve Lock System</li>
            <li>Improve Expenses for Trip Report</li>
        </ul>

        <h3>Version 2.8.54 - Nov 15, 2025</h3>
        <ul>
            <li>Improve Dealer Portal</li>
        </ul>

        <h3>Version 2.8.53 - Nov 14, 2025</h3>
        <ul>
            <li>Show How Many Days Car is on the Yard</li>
            <li>Fix Stops History</li>
            <li>Fix Checkout History</li>
        </ul>

        <h3>Version 2.8.52 - Nov 13, 2025</h3>
        <ul>
            <li>Factoring For Account</li>
            <li>Change BOL conditions</li>
        </ul>

        <h3>Version 2.8.51 - Nov 12, 2025</h3>
        <ul>
            <li>Show Green Quote Count in Orders List If Customer is Active</li>
            <li>Save Contract After Carrier Rest</li>
            <li>Optimization For P&L By Truck Report</li>
        </ul>

        <h3>Version 2.8.50 - Nov 11, 2025</h3>
        <ul>
            <li>Improve File Uploading For New Mobile</li>
            <li>Don't Allow to Set Inactive to Trailer</li>
            <li>Fix Checkout Notifications</li>
        </ul>

        <h3>Version 2.8.49 - Nov 07, 2025</h3>
        <ul>
            <li>Minor Lock Fixes</li>
        </ul>

        <h3>Version 2.8.48 - Nov 07, 2025</h3>
        <ul>
            <li>Add New Option for Cash Received in Trip</li>
            <li>Fix Logic For Receipts Checkbox in Trip Report</li>
            <li>Fix Deleting Files</li>
        </ul>

        <h3>Version 2.8.47 - Nov 05, 2025</h3>
        <ul>
            <li>Broker Fee Paid Filter</li>
            <li>Fix Deleting Child Orders</li>
        </ul>

        <h3>Version 2.8.46 - Nov 05, 2025</h3>
        <ul>
            <li>Ring Central Integration</li>
            <li>Reset Trip Approval If Expense was Updated</li>
        </ul>

        <h3>Version 2.8.45 - Oct 30, 2025</h3>
        <ul>
            <li>Fix Import Files From Central Dispatch</li>
            <li>Improve Sending Emails</li>
        </ul>

        <h3>Version 2.8.44 - Oct 30, 2025</h3>
        <ul>
            <li>Don't Allow to See COD | COP Payment Info if Order is not Accepted</li>
            <li>Order Delete Optimization</li>
            <li>Fix Follow Up Bugs</li>
        </ul>

        <h3>Version 2.8.43 - Oct 30, 2025</h3>
        <ul>
            <li>Fix Price In Quote List</li>
            <li>Allow to Create Quotes on Customer Portal</li>
        </ul>

        <h3>Version 2.8.41 - Oct 30, 2025</h3>
        <ul>
            <li>Fix SMS Follow Ups</li>
        </ul>


        <h3>Version 2.8.40 - Oct 30, 2025</h3>
        <ul>
            <li>Custom Paperwork Time</li>
            <li>Subscribe Emails Issue</li>
        </ul>

        <h3>Version 2.8.39 - Oct 29, 2025</h3>
        <ul>
            <li>Claim Deductions Fixes</li>
            <li>Improve Sending SMS</li>
        </ul>

        <h3>Version 2.8.38 - Oct 28, 2025</h3>
        <ul>
            <li>Fix Color for Carrier in Order List</li>
            <li>Fix Minor Optimization Issue</li>
            <li>Improve MultiUser Layout</li>
        </ul>

        <h3>Version 2.8.37 - Oct 27, 2025</h3>
        <ul>
            <li>Update UI for Source Report</li>
            <li>Fix Minor Errors</li>
            <li>Order List - UI Updates</li>
        </ul>

        <h3>Version 2.8.36 - Oct 23, 2025</h3>
        <ul>
            <li>Allow to Disable ACH Payments in QuickBook</li>
            <li>Fix Import from Ship Cars</li>
        </ul>

        <h3>Version 2.8.35 - Oct 23, 2025</h3>
        <ul>
            <li>Claim Deductions V2</li>
            <li>Remove Ability to Change Order Status For External Users</li>
            <li>Improvements For Locking Orders</li>
        </ul>

        <h3>Version 2.8.34 - Oct 23, 2025</h3>
        <ul>
            <li>Fix Payments Issue on Checkout</li>
            <li>Fix Incorrect Post to CD</li>
            <li>Improvements For Locking Orders</li>
        </ul>

        <h3>Version 2.8.33 - Oct 22, 2025</h3>
        <ul>
            <li>Carrier Pay to Order List</li>
            <li>Fix Trip Points</li>
            <li>Add Option For Auto Assignee "Don't assignee previous customers when I'm inactive" </li>
            <li>Fix Email Marketing Issue</li>
        </ul>

        <h3>Version 2.8.32 - Oct 21, 2025</h3>
        <ul>
            <li>Add Task Visibility</li>
            <li>Fix OTP notification for Driver</li>
            <li>Sync Invoice after Deleting Payment from QB</li>
        </ul>

        <h3>Version 2.8.30 - Oct 20, 2025</h3>
        <ul>
            <li>Show Last Call Tag in Order List</li>
            <li>Add Company's Accounting Email To Contract</li>
        </ul>

        <h3>Version 2.8.29 - Oct 17, 2025</h3>
        <ul>
            <li>Save Previous Carrier Info In Notes After Reset</li>
            <li>Driver's Auth and Phone - Required Before Dispatch</li>
            <li>Fix Issue With Passwords inside Notes</li>
        </ul>


        <h3>Version 2.8.28 - Oct 15, 2025</h3>
        <ul>
            <li>Allow to Do Manual Sync with QB</li>
        </ul>

        <h3>Version 2.8.27 - Oct 15, 2025</h3>
        <ul>
            <li>Fix Trip Map Issue (Google Maps API)</li>
            <li>Improve Source Logic</li>
            <li>Fix File Visibility</li>
        </ul>

        <h3>Version 2.8.25 - Oct 15, 2025</h3>
        <ul>
            <li>Trip Outline Optimization</li>
            <li>Improve Notification For Driver</li>
        </ul>

        <h3>Version 2.8.23 - Oct 14, 2025</h3>
        <ul>
            <li>WorkFlow Builder v1</li>
            <li>Fix Import From SuperDispatch</li>
            <li>Fix Task Updating</li>
        </ul>

        <h3>Version 2.8.22 - Oct 13, 2025</h3>
        <ul>
            <li>QuickBooks Integration Fixes</li>
            <li>Highlight Carrier in Order List</li>
            <li>Show Only Necessary Info in Company Settings</li>
            <li>Opened % Column For Email Marketing Report</li>
            <li>Improve error handling</li>
        </ul>

        <h3>Version 2.8.21 - Oct 10, 2025</h3>
        <ul>
            <li>Improve Auto Assignee Schedule</li>
            <li>Tasks in Sidebar Optimization</li>
            <li>Minor Fixes</li>
        </ul>


        <h3>Version 2.8.19 - Oct 09, 2025</h3>
        <ul>
            <li>Work Authorization Exp In Driver Report</li>
            <li>Create Notification When Trip Was Completed - New Settings for Company</li>
        </ul>

        <h3>Version 2.8.18 - Oct 08, 2025</h3>
        <ul>
            <li>Update Limit for Pickup date in Carrier Request</li>
        </ul>

        <h3>Version 2.8.17 - Oct 08, 2025</h3>
        <ul>
            <li>Fix Follow Up SMS</li>
            <li>Add Exclude Local Trips for Notify After Approving Invoice</li>
            <li>Offline Conversion Changes for Google</li>
        </ul>

        <h3>Version 2.8.16 - Oct 07, 2025</h3>
        <ul>
            <li>Work Authorization Exp - New for contacts</li>
            <li>Fix loading Tasks in sidebar</li>
            <li>Add error label in trip details if address missing in order</li>
            <li>Change required fields for carrier request block</li>
        </ul>

        <h3>Version 2.8.15 - Oct 06, 2025</h3>
        <ul>
            <li>Allow to set visibility in files for other companies in order</li>
            <li>Allow driver login by phone number in mobile app</li>
        </ul>

        <h3>Version 2.8.14 - Oct 02, 2025</h3>
        <ul>
            <li>Minor Changes for Terms & Conditions</li>
            <li>Notes for Bonuses in Contact / Fix date issue</li>
        </ul>

        <h3>Version 2.8.13 - Oct 02, 2025</h3>
        <ul>
            <li>Terms & Conditions</li>
        </ul>

        <h3>Version 2.8.11 - Oct 01, 2025</h3>
        <ul>
            <li>Fixed Adding Trip Deductions</li>
        </ul>


        <h3>Version 2.8.10 - Sep 30, 2025</h3>
        <ul>
            <li>Add SMS Verification from quote form (Only for selected companies)</li>
        </ul>

        <h3>Version 2.8.9 - Sep 29, 2025</h3>
        <ul>
            <li>Claims Damage Notes Fix</li>
        </ul>

        <h3>Version 2.8.8 - Sep 29, 2025</h3>
        <ul>
            <li>Source Report Changes</li>
            <li>Bonuses feature</li>
        </ul>

        <h3>Version 2.8.7 - Sep 25, 2025</h3>
        <ul>
            <li>Lock Orders - Minor Fixes</li>
            <li>Schedule For Auto Assignee - Minor Updates</li>
        </ul>

        <h3>Version 2.8.6 - Sep 23, 2025</h3>
        <ul>
            <li>Fix Checkout Issues</li>
            <li>Fix File Read Backend issue from Sentry</li>
            <li>Fix price component issue</li>
        </ul>

        <h3>Version 2.8.5 - Sep 19, 2025</h3>
        <ul>
            <li>Sources Report Changes</li>
            <li>Driver's Phones and Emails, Dispatcher's Phones - Not Required for Customer Bid</li>
        </ul>

        <h3>Version 2.8.4 - Sep 16, 2025</h3>
        <ul>
            <li>Allow to Schedule Auto Assignee Pause</li>
        </ul>

        <h3>Version 2.8.3 - Sep 16, 2025</h3>
        <ul>
            <li>Correct Address on Insp Photos</li>
            <li>Coords for Stops fix</li>
            <li>Fix Redirect on Order List and Trip Details</li>
            <li>Contact Search - Correct Sorting</li>
            <li>Disable Credit Card for Invoices - Need to test with QB</li>
        </ul>

        <h3>Version 2.8.0 - Sep 16, 2025</h3>
        <ul>
            <li>Price Input Fix</li>
            <li>Real time Checkout Indicator</li>
        </ul>

        <h3>Version 2.7.9 - Sep 15, 2025</h3>
        <ul>
            <li>Fix Notes Visibility</li>
            <li>Filter by Source in Sales Agent Conversion Report</li>
            <li>Update Templates (Agent Phone Number)</li>
            <li>Email Validation for Quote Form</li>
        </ul>

        <h3>Version 2.7.8 - Sep 10, 2025</h3>
        <ul>
            <li>Additional Special Instructions</li>
            <li>Checkout Updates</li>
            <li>Issue with trip list fixed</li>
            <li>Issue with creating contact fixed</li>
        </ul>

        <h3>Version 2.7.7 - Sep 09, 2025</h3>
        <ul>
            <li>Claim Bucket v1</li>
            <li>Orders Missing Issue Fixed</li>
            <li>Notes Visibility Fix</li>
        </ul>

        <h3>Version 2.7.6 - Sep 08, 2025</h3>
        <ul>
            <li>Minor Trip Stops Updates</li>
            <li>Claim Optimization</li>
            <li>Dashboard Search bu Truck fixes</li>
            <li>Accounting Minor Fixes</li>
        </ul>

        <h3>Version 2.7.5 - Sep 04, 2025</h3>
        <ul>
            <li>Notes for Customer - Link with QuickBook</li>
        </ul>

        <h3>Version 2.7.4 - Sep 04, 2025</h3>
        <ul>
            <li>Update logic for converted order on report and dashboard</li>
            <li>Fixed Invoice Amount Discrepancy</li>
            <li>Fixed File Issue on Creating Invoice</li>
        </ul>

        <h3>Version 2.7.3 - Sep 03, 2025</h3>
        <ul>
            <li>Fixed Auto Assignee issue</li>
            <li>Lock orders inside Trip Report and Fixed Rewriting Trip Data</li>
            <li>Trip Polylines fix</li>

        </ul>

        <h3>Version 2.7.1 - Sep 02, 2025</h3>
        <ul>
            <li>Move Local Avl settings up</li>
            <li>Fixed trailer display in the Local Avl List </li>

        </ul>

        <h3>Version 2.7.0 - Sep 02, 2025</h3>
        <ul>
            <li><b>Local Availability v1</b></li>
            <li>Ready To Post (new sub status and button inside order)</li>
            <li>Report Sales Commissions was Fixed</li>
            <li>Set vehicle type based on make and model</li>
            <li>Show Dashboard By Company Type</li>

        </ul>

        <h3>Version 2.6.6 - Aug 29, 2025</h3>
        <ul>
            <li>When one day to Exp Day on Posted Orders Send Email Notification to Dispatcher Email. (</li>
            <li>Fixed loading tasks in sidebar</li>
            <li>Fixed Stop Duplication</li>
        </ul>

        <h3>Version 2.6.5 - Aug 29, 2025</h3>
        <ul>
            <li>Claim report v2</li>
            <li>Fixes issue with attached files in emails</li>
        </ul>
        <h3>Version 2.6.4 - Aug 26, 2025</h3>
        <ul>
            <li>Fixed creating invoices with file</li>
            <li>Fixed price format in adjustments</li>
            <li>Fixed issue with loading trip details</li>
        </ul>
        <h3>Version 2.6.3 - Aug 25, 2025</h3>
        <ul>
            <li>Sales agent conversion report v2</li>
        </ul>
        <h3>Version 2.6.2 - Aug 25, 2025</h3>
        <ul>
            <li>Add a pin to tasks in the sidebar and drag-and-drop capability</li>
            <li>Notify Assignee when invoice status changes from sent to paid</li>
        </ul>

        <h3>Version 2.6.1 - Aug 21, 2025</h3>
        <ul>
            <li>Claim Report V1</li>
        </ul>

        <h3>Version 2.6.0 - Aug 21, 2025</h3>
        <ul>
            <li>Auto-Assignee V2</li>
            <li>Business Hours for Users</li>
            <li>Reason for pause in Auto-Assignee</li>
        </ul>

        <h3>Version 2.5.14 - Aug 20, 2025</h3>
        <ul>
            <li>Google integration for Conversions Checkout Site</li>
        </ul>
        <h3>Version 2.5.13 - Aug 19, 2025</h3>
        <ul>
            <li>TV Dashboard for Brokers</li>
            <li>Fixed issue with incorrect drivers in trip report</li>
            <li>New Freight Verify Integration</li>
            <li>Optimization for ON-HOLD orders</li>
            <li>Pause for Auto Assignee V1</li>
        </ul>

        <h3>Version 2.4.11 - Jun 17, 2025</h3>
        <ul>
            <li>Trip Custom BOL: icon of signature</li>
            <li>Marketing Updates - MongoDB Update 337! - CRON</li>
            <li>Change address in order, trip wrong displayed</li>
            <li>Stop Address WARNING</li>
            <li>After delete stop, type still exist</li>
            <li>Deductions Drivers Error</li>
            <li>P1: Stop Address Location Store + DB Update 338</li>
            <li>Order Tab error</li>
            <li>VIN Import error</li>
            <li>Tracking portal payment info display - HAUL 774</li>
        </ul>
        <h3>Version 2.4.2 - May 27, 2025</h3>
        <ul>
          <li>Fix bug when adding an order to a trip (HAUL-696)</li>
          <li>Correct date issues on Quote and Loadboard lists</li>
          <li>Improve real-time updates by optimizing socket logic</li>
          <li>Fix bug when changing trip name (HAUL-704)</li>
          <li>Prevent error caused by invalid VIN field: _inspectionIndicators not allowed</li>
          <li>Fix redirect issue when navigating from point screen</li>
          <li>Resolve bugs in point input fields</li>
          <li>General bug fixes and improvements (HAUL-715)</li>
          <li>Fix inspection-related bugs on broker orders</li>
          <li>Resolve errors in Inspection Manager (HAUL-723, MongoDB Update 330)</li>
          <li>Fix incorrect display of points on map</li>
          <li>Add inspection indicator to brokerage section (HAUL-722)</li>
        </ul>
        <h3>Version 2.4.1 - May 13, 2025</h3>
        <ul>
          <li>Super Dispatch Integration: Improved COD (Cash on Delivery) data parsing for better accuracy.</li>
          <li>Duplicate History Entries Fixed: No more duplicate entries in trip history.</li>
          <li>Bug Fixes:
            <ul>
              <li>Fixed issue with Follow-Up messages not sending properly.</li>
              <li>Resolved error with displaying damages on BOL.</li>
              <li>Corrected the issue where mobile orders weren’t loading correctly.</li>
              <li>Fixed broken BOL signing link.</li>
              <li>Resolved report issue where "Not Assigned" filter wasn’t working.</li>
              <li>Fixed issue preventing mobile order cloning.</li>
            </ul>
          </li>
          <li>Trip History Optimization: Removed unnecessary loading history for completed orders.</li>
          <li>Improved Stability: Locks now clear correctly when socket connections are lost.</li>
          <li>Inspections Cleanup: Cleaned up additional inspection information for clarity.</li>
          <li>New Filter Added: You can now filter orders by Driver Confirmation status.</li>
          <li>Report Improvements: General bug fixes and filter enhancements to improve reporting accuracy.</li>
        </ul>

        <h3>Version 2.4.0 - May 09, 2025</h3>
        <ul>
          <li>Trip Outline Fixed</li>
          <li>Resource Locking Issue Fixed</li>
          <li>Customer Signature Request</li>
        </ul>
        <h3>Version 2.4.0 - Apr 28, 2025</h3>
        <ul>
          <li>**MAJOR: Multi-User Login</li>
          <li>Remove BodyTypes field from Central Dispatch integration</li>
          <li>Fix blank screen after logout</li>
          <li>Fix trip address error</li>
          <li>Update Reports to version 2.1</li>
          <li>Add dev-app.haulex to allowed domains for geocode in production</li>
          <li>Allow users to clear inspection data</li>
          <li>Fix bug with user index in URL</li>
          <li>Fix checkout calculation issue related to BodyTypes</li>
          <li>Add dynamic "Book Now" option</li>
          <li>Fix marketing business hours notification sending</li>
          <li>Fix dispatcher trips loading error</li>
          <li>Fix duplicate payment send notification error</li>
          <li>Fix issues with first available date display</li>
          <li>Fix trip management and trip-related issues</li>
          <li>Create new template route for system emails or notifications</li>
          <li>Add tasks management after lead creation</li>
          <li>Fix bulk trip creation issues</li>
          <li>Update marketing flow processes</li>
        </ul>
        <h3>Version 2.3.0 - Apr 16, 2025</h3>
        <ul>
          <li><strong>Fixed:</strong>Multi User Login</li>
        </ul>
        <h3>Version 2.2.15 - Apr 04, 2025</h3>
        <ul>
          <li><strong>Fixed:</strong> Lock Split Orders for Carriers</li>
          <li><strong>Fixed:</strong> Follow Count in Leads List</li>
        </ul>
        <h3>Version 2.2.15 - Apr 03, 2025</h3>
        <h4>Accounting & Invoicing</h4>
        <ul>
          <li><strong>Fixed:</strong> Invoice marked as paid in HX but not in QuickBooks</li>
          <li><strong>Updated:</strong> Accounting totals section design</li>
          <li><strong>Fixed:</strong> Total carrier pay (QuickPay)</li>
          <li><strong>Fixed:</strong> Draft accounting bugs</li>
          <li><strong>Set:</strong> "Due on Receipt" as the default payment term in orders</li>
          <li><strong>Fixed:</strong> Quick Pay fee error</li>
          <li><strong>Fixed:</strong> Cash price empty total issue</li>
          <li><strong>Added:</strong> Carrier Pay filter & report</li>
        </ul>

        <h4>Orders & Dispatch</h4>
        <ul>
          <li><strong>Fixed:</strong> Incomplete orders filter</li>
          <li><strong>Fixed:</strong> OH-HOLD status check in sources report</li>
          <li><strong>Fixed:</strong> Order list projection optimization</li>
          <li><strong>Updated:</strong> Suggested available orders</li>
          <li><strong>Fixed:</strong> Suggested orders notification</li>
          <li><strong>Updated:</strong> Change carrier orders list</li>
          <li><strong>Updated:</strong> Change load available list template</li>
          <li><strong>Fixed:</strong> Orders not displaying after completion</li>
          <li><strong>Fixed:</strong> Minor order list optimization</li>
          <li><strong>Added:</strong> Allow dispatchers to create requests</li>
        </ul>

        <h4>Trips & Load Board</h4>
        <ul>
          <li><strong>Updated:</strong> Trips on load board optimization</li>
          <li><strong>Fixed:</strong> Trip error after changes</li>
          <li><strong>Added:</strong> Fuel data to trip list</li>
          <li><strong>Fixed:</strong> Default trip invoice charges</li>
          <li><strong>Fixed:</strong> Driver paid error</li>
        </ul>

        <h4>Filters & Search</h4>
        <ul>
          <li><strong>Optimized:</strong> Search accounts</li>
          <li><strong>Fixed:</strong> Search by invoice number</li>
          <li><strong>Added:</strong> Logic for filtering unpaid carriers</li>
          <li><strong>Fixed:</strong> Fix incomplete filter</li>
          <li><strong>Fixed:</strong> Leads source filter</li>
          <li><strong>Fixed:</strong> Leads pagination issue</li>
          <li><strong>Fixed:</strong> Schedule requests filter</li>
        </ul>

        <h4>Reports & Analytics</h4>
        <ul>
          <li><strong>Fixed:</strong> Report end date changes after generation</li>
          <li><strong>Fixed:</strong> Report one-day start date bug</li>
          <li><strong>Updated:</strong> Reports updates & bug fixes</li>
          <li><strong>Added:</strong> Conversions field to reports</li>
          <li><strong>Fixed:</strong> Source error in reports</li>
        </ul>

        <h4>Marketing & Notifications</h4>
        <ul>
          <li><strong>Fixed:</strong> Marketing cancel email issue</li>
          <li><strong>Updated:</strong> Change marketing templates & subjects</li>
          <li><strong>Fixed:</strong> Suggested layout for marketing</li>
          <li><strong>Fixed:</strong> Notification template errors</li>
          <li><strong>Updated:</strong> Suggested orders updates</li>
        </ul>

        <h4>UI & Design Improvements</h4>
        <ul>
          <li><strong>Fixed:</strong> Customer select layout</li>
          <li><strong>Fixed:</strong> Minor layout improvements</li>
          <li><strong>Fixed:</strong> Expense account select dropdown</li>
          <li><strong>Fixed:</strong> Multi-select styles bug</li>
          <li><strong>Fixed:</strong> Expense amount display issue</li>
          <li><strong>Fixed:</strong> Gallons title error</li>
          <li><strong>Fixed:</strong> Minor switch button issues</li>
        </ul>

        <h4>Integrations & Backend</h4>
        <ul>
          <li><strong>Fixed:</strong> Illegal key in <code>$sort</code> specification</li>
          <li><strong>Updated:</strong> Chrome extension hotfix tested</li>
          <li><strong>Fixed:</strong> Google Tag Manager cross-domain tracking</li>
          <li><strong>Updated:</strong> SuperDispatch parsing fixes</li>
          <li><strong>Fixed:</strong> Freight Verify integration</li>
        </ul>

        <h4>Tracking & Portal Updates</h4>
        <ul>
          <li><strong>Updated:</strong> Tracking portal updates v2.1</li>
          <li><strong>Fixed:</strong> Tracking timezone error</li>
          <li><strong>Fixed:</strong> Tracking portal & inspections photo download</li>
        </ul>
        <h3>Version 2.2.13 - Oct 01, 2024</h3>
        <ul>
          <li>Repost to CD</li>
          <li>Orders - Switching Orders</li>
          <li>TV Display Reports</li>
          <li>Follow Up Version 2</li>
          <li>Book Now Design/Flow Update</li>
        </ul>
        <h3>Version 2.2.12 - Oct 01, 2024</h3>
        <ul>
          <li>Trip Sort Fix</li>
          <li>Notify Customer SMS</li>
          <li>Dashboard Filter Bug</li>
          <li>Trip Request: Fixed Date</li>
          <li>Expense Photo Dispaly Issuf Fixed</li>
          <li>Checkout: Address Required</li>
        </ul>
        <h3>Version 2.2.8 - June 26, 2024</h3>
        <ul>
          <li>Trip Sort Fix</li>
          <li>Other Minor Fixes</li>
        </ul>
        <h3>Version 2.2.7 - June 21, 2024</h3>
        <ul>
          <li>Loadboard: filter by dispatcher error </li>
          <li>VIN search </li>
          <li>Fix trip revenue </li>
          <li>Clearing the input field </li>
          <li>Payment terms </li>
          <li>Account contacts tabs </li>
          <li>Add driver to order with trip, Files</li>
          <li>Super Dispatch Files</li>
          <li>Receipts: Orders not displayed sometimes on mobile </li>
          <li>Quote Form Edit Vehicle Error </li>
          <li>Custom BOL: add phone - TypeError: ctx_r0.options._id.includes is not a function </li>
          <li>Change link to photos at BOL </li>
          <li>Fix NG0955 </li>
          <li>Merge inspection: order number not displayed </li>
          <li>Trip Req. Dates on Complete </li>
          <li>Tracking portal information wrong displayed </li>
          <li>Layout Feedback </li>
          <li>Visibility other contacts/files </li>
          <li>Shop save services </li>
          <li>BOL Date </li>
        </ul>
        <h3>Version 2.2.6 - June 7, 2024</h3>
        <ul>
          <li>Feedback - auto-resend </li>
          <li> Minor Fixes
            <ul>
              <li>Tracking</li>
              <li>Public Orders</li>
              <li>Feedbacks</li>
            </ul>
          </li>
        </ul>
        <h3>Version 2.2.4 - April 15, 2024</h3>
        <ul>
          <li>Tracking Portal UI Update</li>
          <li>Trip Stops Fixed Issues</li>
        </ul>
        <h3>Version 2.2.0 - April 15, 2024</h3>
        <ul>
          <li>Trip List Version 2.2</li>
        </ul>
        <h3>Version 2.2.0 - April 10, 2024</h3>
        <ul>
          <li>Claims Update RD</li>
          <li>Quote Checkout</li>
          <li>Trip Outline Fixes</li>
          <li>Feedback Dispatch Filters</li>
          <li>Other Minor Fixes</li>
        </ul>
        <h3>Version 2.1.1 - March 22, 2024</h3>
        <ul>
          <li>Minor: Fixes Throught out the System
            <ul>
              <li>Note Valiation Removed</li>
              <li>Ship Cars Import</li>
              <li>Quickbooks Custom Maps</li>
              <li>Claims Assignee Issue</li>
              <li>Feedback List Update</li>
              <li>Route Outline</li>
            </ul>
          </li>
        </ul>
        <h3>Version 2.1.0 - March 12, 2024</h3>
        <ul>
          <li>Notes Moved to a Collection **major</li>
          <li>Notes Permissions **major</li>
          <li>Trips Routing Issues *minor</li>
          <li>BOL Layout Issue *minor</li>
        </ul>
        <h3>Version 2.0.9 - Feburary 28, 2024</h3>
        <ul>
          <li>Tracking Map - Ability to Track by Unit</li>
          <li>Trip Report Error Fixed</li>
          <li>Major* - Notes to Collection</li>
        </ul>
        <h3>Version 2.0.7 - Feburary 1, 2024</h3>
        <ul>
          <li>Shop Reports</li>
          <li>Bug Fix: Equipment trailer change in truck</li>
          <li>Bug Fix: Clear Contact from List on Delete</li>
          <li>Tasks: Don't trim task name in sidebar</li>
        </ul>
        <h3>Version 2.0.5 - January 23, 2024</h3>
        <ul>
          <li>Hide Customer Pay</li>
          <li>Recruiter Phone Layout Fix</li>
          <li>P&L Report Layout Fix</li>
          <li>Driver License Dispaly Fix</li>
        </ul>
        <h3>Version 2.0.4 - January 15, 2024</h3>
        <ul>
          <li>Phone Validatoin lib updated</li>
          <li>Carrier Default filter set on Trips</li>
          <li>Expenses Report Issue Fixed</li>
          <li>CRM UI overlay fixed</li>
          <li>Order Stops Dates Fix</li>
          <li>Order Details Edit Bugs Fixed</li>
        </ul>
        <h3>Version 2.0.3 - January 02, 2024</h3>
        <ul>
          <li>Trip Filler Warning</li>
          <li>[RD] Admin Release</li>
          <li>Sidebar titles fixed </li>
        </ul>
        <h3>Version 2.0.1 - January 02, 2024</h3>
        <ul>
          <li>Minor Fixes</li>
          <li>Order Count Criteria</li>
          <li>Loadbaord Pagination</li>
          <li>Dates of Stops</li>
          <li>Carrier adding Driver to Confirmed Order</li>
          <li>Carrier adding Driver to Confirmed Order</li>
        </ul>
        <h3>Version 2.0.1 - January 02, 2024</h3>
        <ul>
          <li>Pre-select on Bulk Update</li>
          <li>Sub-Status in leads filter fix</li>
        </ul>
        <ul>
          <li>Major Release</li>
          <li>Full System UI Redesign</li>
        </ul>
        <h3>Version 2.0.0 - December 21, 2023</h3>
        <ul>
          <li>Major Release</li>
          <li>Full System UI Redesign</li>
        </ul>
        <h3>Version 0.115.2 - October 25, 2023</h3>
        <ul>
          <li>Current Trip Driver Trip on Tracking Map</li>
          <li>Shop Service removed limit of 25 services</li>
        </ul>
        <h3>Version 0.115.1 - October 17, 2023</h3>
        <ul>
          <li>Route Meta Revenue and price per mile</li>
        </ul>
        <h3>Version 0.115.0 - October 15, 2023</h3>
        <ul>
          <li>Select Dispatch Trips</li>
          <li>Order Confirmation Filters</li>
          <li>Notify Last Vehicle Delivery on a Trip</li>
        </ul>
        <h3>Version 0.114.0 - September 6, 2023</h3>
        <ul>
          <li>Dispatch and Truck Trips Reports</li>
          <li>Trips to Route Multi Link</li>
          <li>Expense Trip link Warning</li>
          <li>Claims Tags Added (Driver Claims, Lawsuit)</li>
        </ul>
        <h3>Version 0.113.0 - August 2, 2023</h3>
        <ul>
          <li>Equipment Loan Number has been added next to the load rate.</li>
          <li>Invoice Terms have been updated to include the carrier name.</li>
          <li>Order Stop history has been added to new order creation.</li>
          <li>The alert box has been changed to a within-app modal window.</li>
        </ul>
        <h3>Version 0.112.0 - July 24, 2023</h3>
        <ul>
          <li>Implemented a "Quote Form by Company" feature, allowing users to send quotes directly to the order owner
            from the tracking page.</li>
          <li>Introduced new reports for "Drivers" and "Inventory" to provide comprehensive insights.</li>
          <li>Added "Car-Puller" as a new account type option for user accounts.</li>
          <li>Enhanced the Expenses feature by adding support for Sub Accounts, enabling more detailed financial
            tracking. Additionally, fixed an issue related to the order sorting when changing pages and resolved a
            layout problem.</li>
        </ul>
      </div>
    </div>
  </div>
</div>
